import { api } from "./client";

// --- Типове ---

// Заявка за потвърждаване на достъп с организационен код
export interface ConfirmAccessRequest {
  code2: string; // произволна дължина (0.0.135), само цифри
}

// Отговор от confirm-access и deny-access ендпойнтите
export interface AccessResponse {
  access: boolean;
}

// --- API функции ---

/**
 * POST /access/confirm-access
 * Потвърждава достъпа на потребителя чрез организационен код (code2).
 * JWT токенът се подава автоматично от axios interceptor-а.
 */
export async function confirmAccess(
  data: ConfirmAccessRequest,
): Promise<AccessResponse> {
  const response = await api.post<AccessResponse>(
    "/access/confirm-access",
    data,
  );
  return response.data;
}

/**
 * POST /access/deny-access
 * Премахва достъпа на текущата активна сесия (сетва access = false).
 * JWT токенът се подава автоматично от axios interceptor-а.
 */
export async function denyAccess(): Promise<AccessResponse> {
  const response = await api.post<AccessResponse>("/access/deny-access");
  return response.data;
}
